import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Minus = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M25.53 18H6.47a2 2 0 010-4h19.06a2 2 0 010 4z"
        })
    }));
Minus.displayName = "Minus";
